import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import AdminShell, { eur, dt } from "./AdminShell";

const API = config.API_BASE_URL;

export default function AdminPayments() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [days, setDays] = useState(90);
  const [status, setStatus] = useState("");
  const [company, setCompany] = useState("");
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    axios.get(`${API}/admin/companies`).then((r) => setCompanies(r.data.companies)).catch(() => {});
  }, []);

  const load = useCallback(() => {
    const params = { days };
    if (status) params.status = status;
    if (company) params.company = company;
    axios.get(`${API}/admin/payments`, { params }).then((r) => setData(r.data)).catch(() => {});
  }, [days, status, company]);
  useEffect(() => { load(); }, [load]);

  return (
    <AdminShell>
      <div className="ad-toolbar">
        {[30, 90, 365].map((d) => (
          <button key={d} className={`ad-btn ${days === d ? "primary" : ""}`} onClick={() => setDays(d)}>
            {d} {t("days")}
          </button>
        ))}
        <select className="ad-btn" value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">{t("All statuses")}</option>
          <option value="paid">{t("paid")}</option>
          <option value="created">{t("created")}</option>
          <option value="preauth">{t("preauth")}</option>
        </select>
        <select className="ad-btn" value={company} onChange={(e) => setCompany(e.target.value)}>
          <option value="">{t("All customers")}</option>
          {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        {data && (
          <span className="ad-hint">
            {t("Total collected")}: <strong>{eur(data.totals.paidEur)}</strong> · {data.totals.count} {t("transactions")}
          </span>
        )}
      </div>

      {!data ? (
        <div className="ad-empty">…</div>
      ) : data.payments.length === 0 ? (
        <div className="ad-empty">{t("No payments in this period.")}</div>
      ) : (
        <div className="ad-table-scroll">
          <table className="ad-table">
            <thead>
              <tr>
                <th>{t("Date")}</th>
                <th>{t("Customer")}</th>
                <th>{t("Amount")}</th>
                <th>{t("Status")}</th>
                <th>{t("Description")}</th>
                <th>Order code</th>
              </tr>
            </thead>
            <tbody>
              {data.payments.map((p) => (
                <tr key={p.id}>
                  <td>{dt(p.created_at)}</td>
                  <td>{p.companyName || p._company}</td>
                  <td><strong>{eur(p.amountEur)}</strong></td>
                  <td><span className={`ad-chip ${p.status === "paid" ? "ok" : p.status === "created" ? "" : "grace"}`}>{t(p.status)}</span></td>
                  <td className="ad-hint">{p.customer_trns || p.merchant_trns || "—"}</td>
                  <td className="ad-hint">{p.order_code || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminShell>
  );
}
